<script>
import CardSections from "../../Shared/CardSections.vue";
import TextInput from "../../../../Shared/TextInput.vue";

export default {
    name: "Create",
    components: { TextInput, CardSections },
    props: {
        errors: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                recovery_email: null,
                password: null,
            }),
        }
    },
    methods: {
        submit() {
            this.form.post(
                this.route('nl.employerdashboard.settings.recovery-mail.store', {
                    company_as_uuid: this.$page.props.auth.user.selected_company.uuid,
                })
            )
        },
    }
}
</script>

<template>
    <card-sections
        :title="Lang.get('employerdashboard::pages/settings/recovery/email-recovery.title')"
        :subtitle="Lang.get('employerdashboard::pages/settings/recovery/email-recovery.subtitle')"
        tabName="profile"
        :hideMsg="true"
    >
        <p>{{ Lang.get('employerdashboard::pages/settings/recovery/email-recovery.create.description') }}</p>
        <form @submit.prevent="submit">
            <text-input
                class="w-75 mb-4"
                id="recovery_email"
                v-model="form.recovery_email"
                type="email"
                :label="Lang.get('employerdashboard::pages/settings/recovery/email-recovery.form.recovery_email.label')"
                :placeholder="Lang.get('employerdashboard::pages/settings/recovery/email-recovery.form.recovery_email.placeholder')"
                :error="errors.recovery_email"
            />
            <text-input
                class="w-75"
                id="password"
                v-model="form.password"
                type="password"
                :label="Lang.get('generic.password')"
                :error="errors.password"
            />
            <div class="d-flex mt-4 align-items-center">
                <button type="submit" class="btn btn-primary mr-2">
                    {{ Lang.get('employerdashboard::pages/settings/recovery/email-recovery.buttons.submit_recovery_email') }}
                </button>
            </div>
        </form>
    </card-sections>
</template>

<style scoped>
.btn-link:focus, .btn-link:focus-visible {
    box-shadow: none;
}
</style>
